import React, { SyntheticEvent } from "react";
import { Tabs, Tab } from "@mui/material";
import { ResolutionKeys } from "../types";

interface MyTabsProps {
  selectedTab: ResolutionKeys;
  onTabChange: (event: SyntheticEvent, newValue: ResolutionKeys) => void;
  tabStatus: ResolutionKeys[];
}

const to_use_tabs : ResolutionKeys[] = ["state", "county", "huc2","huc4","huc6", "huc8", "overlay"];

const MyTabs: React.FC<MyTabsProps> = ({ selectedTab, onTabChange, tabStatus }) => {
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center', // This ensures vertical centering
      backgroundColor: 'white',
      padding: '0 20px',
      height: '40px' // Set a fixed height
    }}>
      <div style={{ 
        fontSize: '14px', 
        fontWeight: 600, 
        color: '#1976d2'
      }}>
        Map Resolution
      </div>
      <Tabs
        value={selectedTab}
        onChange={onTabChange}
        sx={{
          minHeight: '40px', // Ensure tabs match container height
          '& .MuiTabs-flexContainer': {
            gap: '4px', // Add gap between tabs
            height: '100%', // Full height of parent
            alignItems: 'center' // Vertically center tab content
          }
        }}
      >
        {to_use_tabs.map((tab) => (
          <Tab
            key={tab}
            label={tab.charAt(0).toUpperCase() + tab.slice(1)}
            value={tab}
            disabled={!tabStatus.includes(tab)}
            sx={{
              minHeight: '32px', // Slightly smaller than container
              border: '1px solid #E2E8F0',
              color: '#718096',
              '&.Mui-selected': {
                backgroundColor: '#1976d2',
                color: 'white',
                border: '1px solid #1976d2'
              }
            }}
          />
        ))}
      </Tabs>
    </div>
  );
};

export default MyTabs;